import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

/**
 * Catch-all route. Until this existed, any unmatched path rendered an empty
 * shell — navbar and footer around nothing.
 *
 * A client-side route cannot set an HTTP status, so this emits `noindex`
 * instead of pretending to be a 404. Returning a real 404 needs a host route
 * manifest, which is Phase B (section 7 of the plan).
 */
export function NotFoundPage() {
  useDocumentMeta({
    title: 'Page not found | Thruline',
    noindex: true
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white pt-32 pb-20 flex items-center justify-center px-6" data-id="element-649" data-mp="3bsi7jhnnluy3">
      <div className="text-center max-w-lg" data-id="element-650" data-mp="1mdae01x8lsn3">
        <p className="text-violet-link text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-651" data-mp="1me3p1f38b4b1">
          Page not found
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold mb-5" data-id="element-652" data-mp="1hgtpv7q1fea0">
          That page doesn’t exist
        </h1>
        <p className="text-white/60 text-base leading-relaxed mb-9" data-id="element-653" data-mp="10dkdup3zm3kp">
          The link may be out of date, or the page may have moved. Here are a couple of good
          places to pick things back up.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-654" data-mp="1a33zu3mzydjs">
          <Link to="/" className="inline-flex items-center gap-2 min-h-[44px] px-7 py-3 rounded-full bg-white text-navy font-semibold text-sm hover:bg-white/90 transition-colors" data-id="element-655" data-mp="1f2gu39g76mwe">
            Back to home
            <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-656" data-mp="1o3ep528nrk2u" />
          </Link>
          <Link to="/solutions" className="inline-flex items-center min-h-[44px] px-7 py-3 rounded-full border border-white/25 text-white font-medium text-sm hover:border-white/50 transition-colors" data-id="element-657" data-mp="1o1bxkdruxiw0">
            Browse solutions
          </Link>
        </div>
      </div>
    </div>;
}